import { IComponentOptions, IController } from "angular";
import { IModalService, IModalServiceInstance } from "angular-ui-bootstrap";
import { IInsight } from "@gtmhub/insights";
import { StateService } from "@uirouter/angularjs";
import { IInsightboard } from "@gtmhub/insightboards";

export class InsightRedirectModalService {
  public static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  public open(params: IInsightRedirectModalBindings): IModalServiceInstance {
    return this.$uibModal.open({
      templateUrl: require("./insight-redirect-modal.jade"),
      windowClass: "medium-small",
      backdrop: true,
      controller: "InsightRedirectModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        insight: (): IInsight => params.insight,
        boardUsage: (): IInsightboard[] => params.boardUsage,
      },
    });
  }
}

export interface IInsightRedirectModalBindings extends Record<string, unknown> {
  insight: IInsight;
  boardUsage: IInsightboard[];
}

export class InsightRedirectModalCtrl implements IController {
  static $inject = ["$uibModalInstance", "$state", "insight", "boardUsage"];

  constructor(private $uibModalInstance: IModalServiceInstance, private $state: StateService, public insight: IInsight, public boardUsage: IInsightboard[]) {}

  public goToBoard(board: IInsightboard): void {
    this.$state.go("gtmhub.insightboard", { dashboardId: board.id });
    this.$uibModalInstance.close();
  }

  public goToInsightsEditor(): void {
    if (this.insight.formatting && this.insight.formatting.isCodeless) {
      this.$state.go("gtmhub.insightCodelessEditor", { name: this.insight.name, dashboardId: null });
      this.$uibModalInstance.close();
      return;
    }

    this.$state.go("gtmhub.insight", { name: this.insight.name, dashboardId: null });
    this.$uibModalInstance.close();
  }
}

export const InsightRedirectModalCtrlComponent: IComponentOptions = {
  controller: InsightRedirectModalCtrl,
  templateUrl: require("./insight-redirect-modal.jade"),
};
